module.exports = new __parcel__URL__("chevron-down.015f45dd.svg").toString();